import { render } from "./TermList.vue?vue&type=template&id=31f8dc8f&ts=true"
import script from "./TermList.vue?vue&type=script&lang=ts"
export * from "./TermList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__